import { MoreVertical } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Switch } from '@/components/ui/switch'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import type { PermissionGroupItem } from '@/types/api'
import type { CombinedColumnDef } from '@/api/dowload-excel.api'
import { formatDateTime } from '@/utils/format'

interface BuildColumnsOptions {
  pageIndex: number
  pageSize: number
  canView?: boolean
  canUpdate?: boolean
  canDelete?: boolean
  onViewDetail?: (item: PermissionGroupItem) => void
  onUpdate?: (item: PermissionGroupItem) => void
  onDelete?: (item: PermissionGroupItem) => void
  onToggleStatus?: (item: PermissionGroupItem) => void
  showUnitColumn?: boolean
}

export function buildColumns({
  pageIndex,
  pageSize,
  canView = true,
  canUpdate = true,
  canDelete = true,
  onViewDetail,
  onUpdate,
  onDelete,
  onToggleStatus,
}: BuildColumnsOptions): CombinedColumnDef<PermissionGroupItem>[] {
  return [
    {
      id: 'stt',
      header: 'STT',
      size: 55,
      align: 'center',
      cell: ({ row }) => row.index + 1 + pageIndex * pageSize,
    },
    {
      accessorKey: 'name',
      header: 'TÊN NHÓM QUYỀN',
      align: 'left',
      cell: ({ row }) => (
        <button
          type="button"
          className="cursor-pointer text-[#CE7A58] hover:text-[#b8694a] font-medium"
          onClick={() => onViewDetail?.(row.original)}
        >
          {row.original.name}
        </button>
      ),
    },
    {
      accessorKey: 'updatedAt',
      header: 'NGÀY CẬP NHẬT',
      size: 130,
      align: 'center',
      cell: ({ getValue }) => formatDateTime(getValue()),
    },
    {
      accessorKey: 'status',
      header: 'TRẠNG THÁI',
      size: 110,
      align: 'center',
      cell: ({ row }) => {
        const item = row.original

        return (
          <div className="flex justify-center">
            <Switch
              disabled={!canUpdate}
              checked={item.status === 1}
              onCheckedChange={() => {
                if (!canUpdate) return
                onToggleStatus?.(item)
              }}
            />
          </div>
        )
      },
    },
    {
      id: 'actions',
      size: 55,
      exportable: false,
      cell: ({ row }) => {
        const canManage = row.original.code !== 'ADMIN'

        return (
          <div className="flex justify-center">
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="icon" className="h-8 w-8">
                  <MoreVertical />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-40">
                {canView && (
                  <DropdownMenuItem
                    className="cursor-pointer"
                    onClick={() => onViewDetail?.(row.original)}
                  >
                    Xem chi tiết
                  </DropdownMenuItem>
                )}
                {canUpdate && canManage && (
                  <DropdownMenuItem
                    className="cursor-pointer"
                    onClick={() => onUpdate?.(row.original)}
                  >
                    Cập nhật
                  </DropdownMenuItem>
                )}
                {canDelete && canManage && (
                  <DropdownMenuItem
                    className="cursor-pointer text-red-600 focus:text-red-600"
                    onClick={() => onDelete?.(row.original)}
                  >
                    Xóa
                  </DropdownMenuItem>
                )}
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        )
      },
    },
  ]
}
